<template>
    <el-form label-position="top" label-width="80px" :model="searchForm">
        <el-row :gutter="30">
            <el-col :span="3" v-show='auth_vendor_type'>
                <el-form-item label="餐飲平台">
                    <el-select v-model="searchForm.CUST_CODE" style="width:100%;" @change="onCustChange">
                        <el-option v-for="item in custOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="品牌">
                    <el-select v-model="searchForm.BRAND_NAME" style="width:100%;" @change="getNameOptions(searchForm.CUST_CODE, searchForm.BRAND_NAME); searchForm.VENDOR_ID='ALL';" :disabled="Branddisabled" filterable allow-create>
                        <el-option v-show="searchForm.type == 'logistics'" label="ALL" value="ALL"></el-option>
                        <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item :label="(searchForm.type == 'logistics') ? '出貨門店':'門店'">
                    <el-select v-model="searchForm.VENDOR_ID" style="width:100%;" :disabled="Vendordisabled" filterable allow-create>
                        <el-option label="全部顯示" value="ALL"></el-option>
                        <el-option v-for="item in nameOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5" v-show="searchForm.type == 'logistics'">
                <el-form-item label="付款對象代號">
                    <el-select v-model="searchForm.PAY_VENDOR" style="width:100%;">
                        <el-option label="ALL" value="ALL"></el-option>
                        <el-option v-for="item in payOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5" v-show="!(searchForm.type == 'logistics')">
                <el-form-item label="快速查詢">
                    <el-select v-model="searchForm.FAST_SEARCH" clearable style="width:100%;" @change="onSelectDate" @clear="onClear('fastsearch')">
                        <el-option label="今日" value="today"></el-option>
                        <el-option label="昨日" value="yesterday"></el-option>
                        <el-option label="本周" value="this_week"></el-option>
                        <el-option label="近一周" value="last_week"></el-option>
                        <el-option label="本月" value="this_month"></el-option>
                        <el-option label="近一個月" value="last_month"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="日期範圍">
                    <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="~" start-placeholder="" end-placeholder="" :disabled-date="disabledDate" @focus="onDateFocus" @calendar-change="onDateChange" @change="onClear('date');" />
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    <el-row type="flex" justify="center">
        <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
            <el-button style="width:100%" type="primary" @click="onSearch" v-show="$store.getters.check_auth('SEARCH')">Search</el-button>
        </el-col>
    </el-row>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus'
    import $api from '@/utils/axios';

    export default defineComponent({
        props: {
            msg: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                auth_vendor_type: false,
                custOptions: [],      // [餐飲平台] 下拉選項
                brandOptions: [],     // [品牌] 下拉選項
                Branddisabled: true,  // [品牌] 下拉狀態
                nameOptions: [],      // [門店] 下拉選項
                Vendordisabled: true, // [門店] 下拉狀態
                payOptions: [],       // [付款對象代號] 下拉選項
                searchForm: {
                    CUST_CODE: '',    // 餐飲平台
                    BRAND_NAME: '',   // 品牌
                    VENDOR_ID: 'ALL', // 門店
                    TRANS_COMP: '',   // 運輸公司的 VENDOR_ID
                    PAY_VENDOR: 'ALL',   // 付款對象代號
                    FAST_SEARCH: '',
                    DATE: [],
                    START_DATE: '',
                    END_DATE: '',
                    type: ''
                },
                chooseDay: null,
            };
        },
        methods: {
            getCustCodeOptions() { // 取得[餐飲平台]下拉
                $api.GET('/api/Outlet/GetCustCodeOptions', {
                }).then((response) => {
                    this.custOptions = response;
                });
            },
            getBrandOptions(CUST_CODE) { // 取得[品牌]下拉
                $api.GET('/api/Outlet/GetBrandNameOptions', {
                    CUST_CODE: CUST_CODE
                }).then((response) => {
                    this.brandOptions = response;
                });
            },
            getNameOptions(CUST_CODE, BRAND_NAME) { // 取得[門店]下拉
                $api.GET('/api/Outlet/GetName2Options', {
                    CUST_CODE: CUST_CODE, BRAND_NAME: BRAND_NAME
                }).then((response) => {
                    this.nameOptions = response;
                });
            },
            getPayOptions(CUST_CODE, VENDOR_ID) { // 取得[付款對象代號]下拉
                $api.GET('/api/Outlet/GetVendorOptions', {
                    CUST_CODE: CUST_CODE, VENDOR_ID:VENDOR_ID
                }).then((response) => {
                    this.payOptions = response;
                })
            },
            onSelectDate() {
                const start = new Date();
                const end = new Date();
                switch (this.searchForm.FAST_SEARCH) {
                    case 'today':
                        this.searchForm.DATE = [start, end];
                        break;
                    case 'yesterday':
                        start.setDate(start.getDate() - 1);
                        end.setDate(end.getDate() - 1);
                        this.searchForm.DATE = [start, end];
                        break;
                    case 'this_week':
                        start.setDate(start.getDate() - start.getDay());
                        end.setDate(end.getDate() - end.getDay() + 6);
                        this.searchForm.DATE = [start, end];
                        break;
                    case 'last_week':
                        start.setDate(start.getDate() - 7);
                        this.searchForm.DATE = [start, end];
                        break;
                    case 'this_month':
                        start.setDate(1);
                        end.setMonth(start.getMonth() + 1);
                        end.setDate(0);
                        this.searchForm.DATE = [start, end];
                        break;
                    case 'last_month':
                        start.setDate(start.getDate() - 30);
                        this.searchForm.DATE = [start, end];
                        break;
                    default:
                        this.searchForm.DATE = [];
                        break;
                }
            },
            onClear(select) {
                switch (select) {
                    case 'fastsearch':
                        this.searchForm.DATE = [];
                        break;
                    case 'date':
                        if (this.searchForm.DATE == null) this.searchForm.FAST_SEARCH = '';
                        break;
                }
            },
            onDateChange(val) { //取得搜尋列-起始日
                this.chooseDay = val[0];
            },
            onDateFocus(e) {
                this.chooseDay = null;
            },
            disabledDate(time) { //查詢日期範圍不可超過30天
                if (!this.chooseDay) return false; 
                if (this.msg == "A100" || this.msg == "B100") { 
                    let timeRange = 30;
                    const disabledStart = new Date(this.chooseDay).getTime() - timeRange * 24 * 60 * 60 * 1000;
                    const disabledEnd = new Date(this.chooseDay).getTime() + timeRange * 24 * 60 * 60 * 1000;
                    return time < disabledStart || time > disabledEnd;
                }

            },
            onCustChange(){
                this.getBrandOptions(this.searchForm.CUST_CODE);
                if(this.searchForm.type == 'logistics') this.searchForm.BRAND_NAME='ALL';
                else this.searchForm.BRAND_NAME='';
                this.searchForm.VENDOR_ID='ALL';
            },
            onSearch() {
                if (this.searchForm.CUST_CODE == '') {
                    ElMessageBox.alert('請選擇餐飲平台', '提示', { confirmButtonText: '確定', type: 'warning' });
                } else if (this.searchForm.BRAND_NAME == '') {
                    ElMessageBox.alert('請選擇品牌', '提示', { confirmButtonText: '確定', type: 'warning' });
                } else {
                    // 日期範圍
                    if (this.searchForm.DATE != null && this.searchForm.DATE.length != 0) {
                        this.searchForm.START_DATE = this.searchForm.DATE[0].toLocaleString('default', { year: "numeric", month: "2-digit", day: "2-digit" });
                        this.searchForm.END_DATE = this.searchForm.DATE[1].toLocaleString('default', { year: "numeric", month: "2-digit", day: "2-digit" });
                    } else {
                        this.searchForm.START_DATE = '';
                        this.searchForm.END_DATE = '';
                    }

                    this.$emit('search', this.searchForm); // 傳遞給父
                }
            },
        },
        beforeMount() {
            switch (localStorage.getItem("VendorType")) {
                case "門店":
                    this.searchForm.CUST_CODE = localStorage.getItem("CustCode");

                    this.searchForm.BRAND_NAME = localStorage.getItem('BrandName');
                    this.Branddisabled = true;

                    this.getNameOptions(localStorage.getItem("CustCode"), localStorage.getItem('BrandName'));
                    this.searchForm.VENDOR_ID = localStorage.getItem('VendorId');
                    this.Vendordisabled = true;
                    break;

                case "運輸公司":
                    this.searchForm.CUST_CODE = localStorage.getItem("CustCode");
                    this.searchForm.TRANS_COMP = localStorage.getItem("CustCode");

                    this.searchForm.BRAND_NAME = localStorage.getItem('BrandName');
                    this.Branddisabled = true;

                    this.searchForm.VENDOR_ID = '';
                    this.Vendordisabled = true;
                    break;

                case "品牌":
                    this.searchForm.CUST_CODE = localStorage.getItem("CustCode");

                    this.searchForm.BRAND_NAME = localStorage.getItem('BrandName');
                    this.Branddisabled = true;

                    this.getNameOptions(localStorage.getItem("CustCode"), localStorage.getItem('BrandName'));
                    this.Vendordisabled = false;
                    break;

                case "餐飲平台":
                    this.searchForm.CUST_CODE = localStorage.getItem("CustCode");

                    this.getBrandOptions(localStorage.getItem("CustCode"));
                    this.Branddisabled = false;

                    this.Vendordisabled = false;
                    break;

                case "平台管理":
                    this.auth_vendor_type = true; // [餐飲平台]下拉欄位
                    this.getCustCodeOptions();
                    this.searchForm.CUST_CODE = '';
                    this.getBrandOptions("");
                    this.Branddisabled = false;

                    this.Vendordisabled = false;
                    break;
            }
        },
        mounted() {
            // 預設搜尋列 - 起始日期
            const start = new Date();
            const end = new Date();
            switch (this.msg) {
                case "A100": //訂單追蹤
                    this.searchForm.DATE = [start, start];
                    this.searchForm.type = 'track';
                    break;
                case "B100": //訂單紀錄
                    start.setDate(1);
                    this.searchForm.DATE = [start, end];
                    this.searchForm.type = 'record';
                    break;
                case "B110": //物流費用
                    this.searchForm.type = 'logistics';
                    if (this.searchForm.BRAND_NAME == '') this.searchForm.BRAND_NAME = 'ALL';
                    this.getPayOptions(localStorage.getItem("CustCode"), localStorage.getItem("VendorId"));
                    break;
                case "C100": //匯款紀錄
                    this.searchForm.type = 'record';
            }
        }
    });

</script>